// ABOUTME: `mic_voice_control` (dev + staging, owner 2026-10-08) as a tiny external store: the consent rows and the privacy policy
// ABOUTME: sit deep in the rail/menu/policy panels with no prop path from App. Default (flag-off, prod) is today's behaviour.

import { useSyncExternalStore } from 'react';

let on = false;
const listeners = new Set();

/** App sets it from the ui_experiment map; a value that does not change emits nothing. */
export function setMicVoiceControl(value) {
  const next = !!value;
  if (next === on) return;
  on = next;
  listeners.forEach((l) => l());
}

export const getMicVoiceControl = () => on;

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** True when the microphone button is the one voice control (no voice row in the panel; policy says how to switch off). */
export function useMicVoiceControl() {
  // Server snapshot too: some suites (and the plates) render through renderToStaticMarkup, which requires one.
  return useSyncExternalStore(subscribe, getMicVoiceControl, getMicVoiceControl);
}
